var $ = require('jquery');

function clone (object) {
	return $.extend(true, {}, object);
}

module.exports = clone;
